import { Injectable } from 'angular-ts-decorators';

import { Legacy } from '@shared/app/scripts/services/legacy';
import { LegacyProductList } from '@classes/legacy-product-list';

export interface IProductsInSetModel {
  code: string;
  description: string;
  barcode: string;
}

/**
 * Service that finds queries foxpro for product stock info
 */
@Injectable('legacyProduct')
export class LegacyProduct {
  constructor(private legacy: Legacy) {
    'ngInject';
  }

  /**
   * Get product by barcode. Optionally allows for filtering by any value
   * @param {string} barcode
   * Barcode of the product we are looking for
   * @param {Partial<Arrayed<ILegacyFullStockObject>>} filterKeys
   * Object of keys ILegacyFullStockObject, each with array of allowed values
   * @return {LegacyProductList}
   * Processed value
   */
  getByBarcode(barcode: string): ng.IPromise<{
    stock: LegacyProductList;
    productsInSet: IProductsInSetModel[];
  }> {
    return this.legacy.getStock5(barcode).then((response) => {
      return {
        stock: new LegacyProductList(response.stock),
        productsInSet: response?.productsInSet?.map((productInfo) => {
          return {
            barcode: productInfo.ean,
            ...productInfo,
          };
        }),
      };
    });
  }
}
